<template>
    <section class="main-container">
        <h2 class="font-48 color-primary2 fw-500 text-start text-start">
            {{ $t(translationKey + ".title") }}
        </h2>
        <p class="font-18 text-start">{{ $t(translationKey + ".description") }}</p>
        <div class="gridDifferentTypeOfStorage">
            <div class="gridDifferentTypeOfStorage-card" v-for="(option, i) in options" :key="i">
                <div class="img-div">
                    <img :src="require('@/assets/images/diffStorage/' + option.image)"
                        :alt="$t(translationKey + '.option' + (i + 1) + '.name').toString()" />
                </div>
                <h3 class="font-24 fw-500  text-start">
                    {{ $t(translationKey + ".option" + (i + 1) + ".name") }}
                </h3>

            </div>
        </div>
        <a :href="`${BASE_FRONT_URL}` + `/${$i18n.locale}` + '/dashboard/rfq' + `${refId ? '?ref=' + refId : ''}`">
            <CommonButton translationKey="store_with_us" />
        </a>
    </section>
</template>
  
<style lang="scss" scoped>
.main-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 120px 0px;
    background-color: #F8F9FB;


    h2 {
        background-color: transparent !important;
        padding: 0px;
        margin: 0px;
    }

    p {
        color: #5d5d5d;
        background-color: transparent !important;
        width: 943px;
        text-align: center;
        margin: 32px 0px 0px;
        padding: 0px;

        @media screen and (max-width: 1200px) {
            width: 500px;
        }

        @media screen and (max-width: 500px) {
            width: 100%;
            padding: 0px 24px;
        }
    }

    .gridDifferentTypeOfStorage {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        gap: 48px;
        margin: 32px 0px 32px 0px;
        padding: 0px;

        @media screen and (max-width: 1200px) {
            flex-wrap: wrap;
            justify-content: center;
        }
    }

    .gridDifferentTypeOfStorage-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 256px;
        padding: 16px;

        .img-div {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
            height: 100px;
            background: #ffffff;
            box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.1);
            border-radius: 14px;
            padding: 8px;
            margin: 0px;
        }

        h3 {
            color: #363636;
            background-color: transparent !important;
            padding: 0;
            margin: 12px 0px;
        }


    }
}
</style>
  
<script  >
 
import CommonButton from "@/components/global/CommonButton.vue";
import { env } from "@/static/env";
export default {
    props: ["translationKey"],
    components: {
        CommonButton,
    },
    computed: {
        refId() {
            return this.$route.query.ref;
        }
    },
    data: () => ({
        BASE_FRONT_URL: env.BASE_FRONT_URL,
        options: [
            { image: "dry.png" },
            { image: "ambient.png" },
            { image: "chilled.png" },
            { image: "frozen.png" },
        ],
    }),
} ;
</script>
  